import { BIOLOGY_CATEGORIES } from '@shared/types/categories'
import type { BiologyCategory } from '@shared/types'

interface CategorySelectorProps {
  selectedCategory: BiologyCategory | null
  onSelect: (category: BiologyCategory) => void
}

export default function CategorySelector({ selectedCategory, onSelect }: CategorySelectorProps) {
  return (
    <div className="space-y-4">
      <h2 className="text-lg font-semibold text-gray-900">选择生物学科目录</h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {BIOLOGY_CATEGORIES.map((category) => (
          <button
            key={category.id}
            onClick={() => onSelect(category.name)}
            className={`p-4 rounded-lg border-2 text-left transition-all ${
              selectedCategory === category.name
                ? 'border-primary-600 bg-primary-50'
                : 'border-gray-200 bg-white hover:border-primary-300 hover:bg-gray-50'
            }`}
          >
            <div className="font-medium text-gray-900 mb-1">{category.name}</div>
            <div className="text-sm text-gray-600 line-clamp-2">{category.description}</div>
          </button>
        ))}
      </div>
    </div>
  )
}
